<template>
<div class="absolute top-0 left-0 bb-zindex1 bb-bc10 bb-h100vh bb-w100vw bb-fullscreen bb-usnone" @click="highlightCancelBtn">
  <div class="mx-auto relative bb-vcr bb-br5 border-box p3 bb-bc11
  bb-w24pt12 bb-sm-w30 bb-mid-w42" v-on:click.stop>
    <div class="center pt2 bb-ff3 bb-fs1pt2 bb-fc16"
    v-if="!userLoggedIn">{{ $lang.messages.verify_account }}</div>
    <div class="center pt2 bb-ff2 bb-fs1pt2 bb-fc2"
    v-if="userLoggedIn">{{ $lang.messages.payment_process }}</div>
    <div class="center mt1 bb-ff2 bb-fc15" v-if="!userLoggedIn && !showVerificationCode">{{ $lang.messages.payment_sbtitle }}</div>
    <div class="center mt1 bb-ff2 bb-fc15" v-if="showVerificationCode">{{ $lang.messages.token_noti }}</div>
    <div class="center bb-ff2 mt1" v-if="!userLoggedIn">
      <div class="clearfix" v-if="!hideFields">
        <div class="col col-12 md-col-6 bb-md-pr0pt5 border-box bb-mt1pt5 relative">
          <div class="absolute left-0 bb-top1 bb-transform1 pl2 bb-zindexn1 bb-fc14 bb-ff2"
          :class="{'bb-transform3': inputFirstNameActive}">{{$lang.messages.p1}}</div>
          <input type="text"
            class="bb-bc-transp bb-md-right
            border-box pl2 bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-left0
            bb-brd-right0 bb-brd-top0"
            :class="[ formSend && userInfo.first_name === '' ? 'bb-brd5' :
            'bb-brd-bot2 bb-fc16']"
            v-model="userInfo.first_name"
            @blur="blurFirstNamePlaceholder"
            @change="resetValidation"
            @focus="inputFirstNameClicked">
        </div>
        <div class="col col-12 md-col-6 bb-md-pl0pt5 border-box bb-mt1pt5 relative">
          <div class="absolute left-0 bb-top1 bb-transform1 pl2 bb-md-pl1pt5 bb-zindexn1 bb-fc14 bb-ff2"
          :class="{'bb-transform3': inputLastNameActive}">{{$lang.messages.p7}}</div>
          <input type="text"
            class="bb-bc-transp bb-md-right
            border-box pl2 bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-left0
            bb-brd-right0 bb-brd-top0"
            :class="[ formSend && userInfo.last_name === '' ? 'bb-brd5' :
            'bb-brd-bot2 bb-fc16']"
            v-model="userInfo.last_name"
            @blur="blurLastNamePlaceholder"
            @change="resetValidation"
            @focus="inputLastNameClicked">
        </div>
        <div class="col col-12 md-col-6 bb-md-pr0pt5 border-box bb-mt1pt5 relative">
          <div class="absolute left-0 bb-top1 bb-transform1 pl2 bb-zindexn1 bb-fc14 bb-ff2"
          :class="{'bb-transform3': inputNumberActive}">{{$lang.messages.p2}}</div>
          <input type="text"
            class="bb-bc-transp bb-md-left border-box
            pl2 bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-left0
            bb-brd-right0 bb-brd-top0"
            :class="[invalidPhoneNumber ? 'bb-brd5 bb-fc5' : 'bb-brd-bot2 bb-fc16']"
            v-model="userInfo.phone_number"
            @blur="blurNumberPlaceholder"
            @focus="inputNumberClicked">
        </div>
        <div class="col col-12 md-col-6 bb-md-pl0pt5 bb-mt1pt5 relative">
          <div class="absolute left-0 bb-top1 bb-transform1 pl2 bb-md-pl1pt5 bb-zindexn1 bb-fc14 bb-ff2"
          :class="{'bb-transform3': inputMailActive}">{{$lang.messages.p3}}</div>
          <input type="text"
            class="bb-bc-transp border-box pl2
            bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-left0
            bb-brd-right0 bb-brd-top0"
            :class="[invalidEmail ? 'bb-brd5 bb-fc5' : 'bb-brd-bot2 bb-fc16']"
            v-model="userInfo.email"
            @blur="blurMailPlaceholder"
            @focus="inputMailClicked">
        </div>
        <div class="col col-12 mt2 bb-ff2 bb-fs1 bb-fc3
        left-align">
          {{ $lang.messages.fill_require }}
        </div>
      </div>
      <div class="relative bb-min-h10" v-if="(hideFields && !showVerificationCode)">
        <img class="absolute bb-vhcr bb-w5 bb-h5"
          src="../assets/images/loader.svg"></img>
      </div>
      <div class="mt2 bb-min-h8" v-if="showVerificationCode">
        <div class="relative mt3">
          <div class="absolute left-0 bb-top1 bb-transform1 bb-zindexn1 bb-fc14 bb-ff2 bb-w100p"
          :class="{'bb-op0': inputCodeActive}">{{$lang.messages.p4}}</div>
          <input type="text"
            class="bb-bc-transp border-box center  
            bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-left0
              bb-brd-right0 bb-brd-top0"
            v-model="userInfo.verification_code"
            ref="code"
            :class="[ (codeSend && userInfo.verification_code === '') ||
            invalidCode ? 'bb-brd5 bb-fc5' : 'bb-brd-bot2 bb-fc16']"
            @blur="blurCodePlaceholder" @change="resetValidation"
            @focus="inputCodeClicked">
        </div>
        <div class="bb-mt1pt2 bb-ff2 bb-fs1 bb-fc3 left-align">
          {{ $lang.messages.fill_require }}
        </div>
        <div class="mt2 left-align">
          <div class="inline-block bb-brd-left0
            bb-brd-right0 bb-brd-top0 bb-pointer bb-brd-bot2 bb-fc14 bb-ff2"
            @click="resendCode">Resend Code</div>
        </div>
      </div>
    </div>
    <div class="center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp
      bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3
      bb-h2pt8 bb-py1pt25 bb-lh0 bb-transition2 bb-mt2pt6"
      @click="sendCode" v-if="!showVerificationCode && !userLoggedIn">
      {{ $lang.messages.request_code }}
    </div>

    <div class="center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp
      bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3
      bb-h2pt8 bb-py1pt25 bb-lh0 bb-transition2 bb-mt3pt56 relative"
      @click="checkout" v-if="paymentBtn">
        {{ $lang.messages.verify_account }}
    </div>

    <div class="center bb-mt1pt3 bb-ff3 bb-pointer mb1 bb-transition2
     bb-fc8-hover bb-h1pt5 bb-lh1pt5 bb-fc14" @click="cancelPayment"  :class="[
     cancelTransitionClass, cancelBtnHighlighted ? 'bb-scale-1pt2' : '' ]">{{ $lang.messages.cancel }}</div>
    <div class="absolute bb-pointer bb-top3 bb-left2 bb-mln0pt6" v-if="showVerificationCode"
    @click="paymentBack">
      <i class="bb-fc14 material-icons bb-fs2pt17 bb-usnone">&#xE5CB;</i>
    </div>
  </div>
</div>
</template>

<script>
var validator = require('email-validator')
export default {
  name: 'loginModal',
  props: ['loginData'],
  data () {
    return {
      showVerificationCode: false,
      hideFields: false,
      payfortEnabled: false,
      inputFirstNameActive: false,
      inputLastNameActive: false,
      inputNumberActive: false,
      inputMailActive: false,
      inputCodeActive: false,
      showArrow: false,
      formSend: false,
      userInfo: {
        phone_number: '',
        first_name: '',
        last_name: '',
        email: '',
        verification_code: ''
      },
      invalidEmail: false,
      codeSend: false,
      cancelTransitionClass: 'bb-transition2',
      cancelBtnHighlighted: false,
      invalidCode: false,
      invalidPhoneNumber: false
    }
  },
  computed: {
    userToken () {
      if (this.$store.getters.getUserToken) {
        return this.$store.getters.getUserToken
      }
    },
    paymentBtn () {
      if (this.showVerificationCode || this.userLoggedIn) {
        return true
      }
    },
    tokenError () {
      return this.$store.getters.getTokenError
    },
    phoneError () {
      return this.$store.getters.getPhoneError
    },
    userLoggedOut () {
      return this.$store.getters.getLoggedIn
    },
    userCredentials () {
      return this.$store.getters.getUserCredentials
    }
  },
  watch: {
    userToken: function () {
      if (this.$store.getters.getUserToken) {
        if (this.hideFields) {
          this.showVerificationCode = true
          this.$nextTick(function () {
            this.$refs.code.focus()
            this.inputCodeActive = true 
          })
        }
      }
    },
    'userInfo.verification_code': function () {
      if (this.codeSend) {
        this.codeSend = false
      }
      if (this.invalidCode) {
        this.invalidCode = false
      }
    },
    tokenError: function () {
      this.invalidCode = true
      this.$emit('emitNotification', this.$lang.messages.err4)
    },
    phoneError: function () {
      this.invalidPhoneNumber = true
      this.hideFields = false
      this.$emit('emitNotification', this.$lang.messages.err5)
    },
    'userInfo.phone_number': function () {
      if (this.invalidPhoneNumber) {
        this.invalidPhoneNumber = false
      }
    },
    'userInfo.email': function () {
      if (this.invalidEmail) {
        this.invalidEmail = false
      }
    },
    userLoggedOut: function () {
      if (!this.$store.getters.getLoggedIn) {
        this.userInfo.verification_code = ''
        this.userInfo.first_name = ''
        this.userInfo.last_name = ''
        this.userInfo.phone_number = ''
        this.userInfo.email = ''
        this.showVerificationCode = false
        this.showArrow = false
      }
    },
    userCredentials: function () {
      this.$localStorage.set('token', this.$store.getters.getUserCredentials.profileToken)
      this.$localStorage.set('profileId', this.$store.getters.getUserCredentials.profileId)
      this.$localStorage.set('username', this.$store.getters.getUserCredentials.username)
      this.$store.commit('SET_LOGGEDIN', true)
      this.$store.commit('SET_SHOW_MODAL', false)
    }
  },
  methods: {
    getParameterByName: function (name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[\[\]]/g, "\\$&")
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, " "))
    },
    paymentBack: function () {
      this.showVerificationCode = false
      this.hideFields = false
    },
    sendCode: function () {
      this.formSend = true
      if (this.userInfo.first_name !== '' && this.userInfo.last_name !== '' &&
        this.userInfo.phone_number !== '' && this.userInfo.email) {
        if (validator.validate(this.userInfo.email)) {
          this.hideFields = true
          var params = {
            first_name: this.userInfo.first_name,
            last_name: this.userInfo.last_name,
            email: this.userInfo.email,
            phone_number: this.userInfo.phone_number,
            via: 'sms'}
          this.$store.dispatch('LOAD_USER_TOKEN', params)
        } else {
          this.invalidEmail = true
          this.$emit('emitNotification', this.$lang.messages.err2)
        }
      } else {
        if (this.userInfo.phone_number === '') {
          this.invalidPhoneNumber = true
        }
        if (this.userInfo.email === '') {
          this.invalidEmail = true
        }
        this.$emit('emitNotification', this.$lang.messages.err3)
      }
    },
    resendCode: function () {
      var params = {
        first_name: this.userInfo.first_name,
        last_name: this.userInfo.last_name,
        email: this.userInfo.email,
        phone_number: this.userInfo.phone_number,
        via: 'sms'}
      this.$store.dispatch('LOAD_USER_TOKEN', params)
    },
    cancelPayment: function () {
      this.showVerificationCode = false
      this.hideFields = false 
      this.invalidCode = false
      this.codeSend = false
      this.invalidEmail = false
      this.formSend = false
      this.showArrow = false
      this.invalidPhoneNumber = false
      this.$store.commit('SET_USER_TOKEN', null)
      this.$store.commit('SET_SHOW_MODAL', false)
      this.$emit('cancelLoginEmit')
    },
    resetValidation: function (event) {
      if (this.formSend) {
        this.formSend = false
      }
      if (this.invalidEmail) {
        this.invalidEmail = false
      }
      if (this.invalidPhoneNumber) {
        this.invalidPhoneNumber = false
      }
    },
    highlightCancelBtn: function () {
      this.cancelBtnHighlighted = true
      var self = this
      setTimeout(function () {
        self.cancelBtnHighlighted = false
      }, this.$utilities.getTransitionDurationOfClass('.' + this.cancelTransitionClass) * 1000)
    },
    validateNumber: function (val) {
      return /^\d+$/.test(val)
    },
    resetPlaceholder: function (event, placeholder) {
      event.target.placeholder = placeholder
    },
    blurFirstNamePlaceholder: function (event) {
      if (event.target.value.length <= 0) {
        this.inputFirstNameActive = false
      }
    },
    blurLastNamePlaceholder: function (event) {
      if (event.target.value.length <= 0) {
        this.inputLastNameActive = false
      }
    },
    blurNumberPlaceholder: function (event) {
      if (event.target.value.length <= 0) {
        this.inputNumberActive = false
      }
    },
    blurMailPlaceholder: function (event) {
      if (event.target.value.length <= 0) {
        this.inputMailActive = false
      }
    },
    blurCodePlaceholder: function (event) {
      if (event.target.value.length <= 0) {
        this.inputCodeActive = false
      }
    },
    checkout: function () {
      this.$store.commit('SET_USER_INFO', this.userInfo)
      this.$store.dispatch('LOAD_TOKEN', this.userInfo)
    },
    inputFirstNameClicked: function () {
      this.inputFirstNameActive = true 
    },
    inputLastNameClicked: function () {
      this.inputLastNameActive = true 
    },
    inputNumberClicked: function () {
      this.inputNumberActive = true 
    },
    inputMailClicked: function () {
      this.inputMailActive = true 
    },
    inputCodeClicked: function () {
      this.inputCodeActive = true 
    }
  },
  mounted () {
    this.payfortEnabled = (this.getParameterByName('payfort') === 'true')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/loginModal.vue